import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBBtn,
  MDBInput,
  MDBPopover,
  MDBPopoverHeader,
  MDBPopoverBody,
} from "mdb-react-ui-kit";
import ExportDropdown from "../common/ExportDropdown";
import CustomizableColumnDropdown from "./CustomizableColumnDropdown";

const LegislatorTableHeader = ({
  columns,
  visibleColumns,
  onToggleColumn,
  onSearch,
  onExport,
  setFilterSideNavIsOpen,
  filterSideNavIsOpen,
  exportLoading = { csvLoading: false, pdfLoading: false },
  exportProgress = { csv: 0, pdf: 0 },
  activeSession,
}) => {
  return (
    <>
      <MDBRow className="pt-3 g-1">
        <MDBCol size="lg" className="text-center text-md-start mb-3 mb-md-0">
          <h6 className="lead mb-0">
            {new Date(activeSession?.startDate).getFullYear()} (
            {activeSession?.type}) Session
          </h6>
          <h3 className="title">Legislator Explorer</h3>
        </MDBCol>
        <MDBCol size="auto">
          <div className="d-flex justify-content-end helpers">
            <MDBPopover
              tag="a"
              href="#"
              btnChildren={<MDBIcon fas icon="info-circle" />}
              dismiss
              placement="top"
            >
              <MDBPopoverHeader>Quick Search</MDBPopoverHeader>
              <MDBPopoverBody>
                Using the search bar to quickly find who are looking for.
              </MDBPopoverBody>
            </MDBPopover>
            {/* <a
              href="https://www.legmt.gov/committees/"
              target="_blank"
              className="ms-1"
            >
              <MDBIcon fas icon="question-circle" />
            </a> */}
          </div>
          <div className="d-flex justify-content-end">
            <MDBBtn
              className="me-1"
              onClick={() => setFilterSideNavIsOpen(!filterSideNavIsOpen)}
            >
              <MDBIcon fas icon="filter" /> Filters
            </MDBBtn>
            <ExportDropdown
              onExport={onExport}
              exportLoading={exportLoading}
              exportProgress={exportProgress}
            />
          </div>
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol>
          <CustomizableColumnDropdown
            columns={columns}
            visibleColumns={visibleColumns}
            onToggleColumn={onToggleColumn}
          />
        </MDBCol>
        <MDBCol>
          <MDBInput
            label="Search Legislators"
            className="bg-white mb-2"
            type="text"
            onChange={(e) => onSearch(e.target.value)}
          />
        </MDBCol>
      </MDBRow>
    </>
  );
};

export default LegislatorTableHeader;
